import { isEmpty } from 'lodash'
import { findPeopleWithoutDuplicates } from '../services/loftCalendarEvents'
import { getConvertedId } from '../office/graphApi/utils'
import Base from './base'
import { Guest, Recipient } from '../types/loft'
import { User } from '../types/user'

export default class CalendarLofting extends Base {
  async getInternalDomains() {
    const response = await this.api.get('team_internal_domain')

    return response.data.domains
  }

  async loft(payload: Record<string, unknown>) {
    const { isCreation, event_id, ...event } = payload
    const convertedEventId = typeof event_id === 'string' ? getConvertedId(event_id) : event_id
    if (!isCreation && typeof convertedEventId === 'string') {
      return this.api.put(
        `calendar_events_lofting/azure?event_id=${encodeURIComponent(convertedEventId)}`,
        event
      )
    }
    return this.api.post('calendar_events_lofting', { ...payload, event_id: convertedEventId })
  }

  async getLoftedEvent(itemId: string, auth?: User) {
    const emptyCrmReferences = { who: null, what: null }
    const emptyEventData = {
      event: null,
      mainGuest: null,
      crmReferences: emptyCrmReferences,
    }

    const convertedItemId = getConvertedId(itemId)

    try {
      const { data: event } = await this.api.get(
        `calendar_events_lofting/azure?event_id=${encodeURIComponent(convertedItemId)}`
      )

      if (!auth) {
        return event
      }

      const [person] = await findPeopleWithoutDuplicates(
        [
          {
            emailAddress: event.recipient_email,
          } as Guest | Recipient,
        ],
        auth
      )

      return {
        event,
        crmReferences: isEmpty(event.crm_references) ? emptyCrmReferences : event.crm_references,
        mainGuest: {
          email: event.recipient_email,
          name: event.recipient_name,
          ...person,
        },
      }
    } catch (e) {
      return emptyEventData
    }
  }
}
